export const STATES = [
	'Aguascalientes',
	'Baja California',
	'Baja California Sur',
	'Campeche',
	'Chiapas',
	'Chihuahua',
	'Coahuila',
	'Colima',
	'Durango',
	'Guanajuato',
	'Guerrero',
	'Hidalgo',
	'Jalisco',
	'Estado de México',
	'CDMX',
	'Michoacán',
	'Morelos',
	'Nayarit',
	'Nuevo León',
	'Oaxaca',
	'Puebla',
	'Querétaro',
	'Quintana Roo',
	'San Luis Potosí',
	'Sinaloa',
	'Sonora',
	'Tabasco',
	'Tamaulipas',
	'Tlaxcala',
	'Veracruz',
	'Yucatán',
	'Zacatecas',
];

// People that can see notificacions
export const EMAILS_ALLOWED_FOR_READING_NOTIFICATIONS = [
	'flopezramirez@hotmail.com',
	'mesadecontrol@piluniformes.mx',
];

// People that can see notificacions
export const EMAILS_ALLOWED_FOR_TICKETS = [
	'flopezramirez@hotmail.com',
	'andrea@hotmail.com',
	'glopezberistain@hotmail.com',
	'teo.her.cv@gmail.com',
	'jonathanserna@piluniformes.com.mx'
];

// Tolling types
export const TOLLING_TYPES = [
	{
		code: 'TYPE_1',
		label: 'Corte',
	},
	{
		code: 'TYPE_2',
		label: 'Estampado',
	},
	{
		code: 'TYPE_3',
		label: 'Bordado',
	},
	{
		code: 'TYPE_4',
		label: 'Confección',
	},
];

// Dynamic templates' id from DataGrid API dashboard
export const EMAIL_TEMPLATES = {
	'pilu-autorization-order': 'd-2a4ccce7853b40aca4e36e5d290f6a2e',
	'saro-authorization-order': 'd-b10d1dca4ffd4331965446c893bc8d09',
};

export const VIEW_OPTIONS = [
	'Todo',
	'Administradores',
	'Mesa de control',
	'Asesores',
	'Operadores',
];

export const DAYS = [
	'Lunes',
	'Martes',
	'Miércoles',
	'Jueves',
	'Viernes',
	'Sábado',
	'Domingo',
];

export const PRIORITIES = [
	{ name: 'LOW', label: 'Baja' },
	{ name: 'MED', label: 'Media' },
	{ name: 'HIG', label: 'Alta' },
];

export const DIVISIONS = [
	{ name: 'PUE', label: 'Puebla' },
	{ name: 'MEX', label: 'México' },
	{ name: 'VER', label: 'Veracruz' },
	{ name: 'CEL', label: 'Celaya' },
	{ name: 'MTY', label: 'Monterrey' },
	{ name: 'TAB', label: 'Tabasco' },
	{ name: 'QUE', label: 'Querétaro' },
];

export const TYPES_OF_PACKING = [
	{ name: 'EMP1', label: 'Granel' },
	{ name: 'EMP2', label: 'Personalizado' },
	{ name: 'EMP3', label: 'Granel y Personalizado' },
];

export const CLIENT_TYPES = [
	{ name: 'CLI1', label: 'Nuevo' },
	{ name: 'CLI2', label: 'Recuperado' },
	{ name: 'CLI3', label: 'Cautivo' },
];

export const STATUS = [
	{ name: 'ICF', label: 'En configuración' },
	{ name: 'VAL', label: 'Validado' },
	{ name: 'AUT', label: 'Autorizado' },
	{ name: 'REL', label: 'Liberado' },
	{ name: 'DLY', label: 'Retrasado' },
	{ name: 'NST', label: 'No empezado' },
	{ name: 'IPR', label: 'En progreso' },
	{ name: 'FIN', label: 'Finalizado' },
];

export const ANNOTATION_TYPES = [
	{ name: 'OBS', label: 'Observación' },
	{ name: 'COM', label: 'Compromiso' },
	{ name: 'STR', label: 'Estrategia' },
	{ name: 'ALE', label: 'Alerta' },
];

export const EVENT_TYPES = [
	{ name: 'SUC', label: 'success', text: 'Éxito' },
	{ name: 'INF', label: 'info', text: 'Info' },
	{ name: 'WAR', label: 'warning', text: 'Precaución' },
	{ name: 'ERR', label: 'error', text: 'Error' },
];

export const PROGRESS_OP = [
	{ name: 'lt', label: 'Menor que' },
	{ name: 'lte', label: 'Menor o igual que' },
	{ name: 'e', label: 'Igual a' },
	{ name: 'gt', label: 'Mayor que' },
	{ name: 'gte', label: 'Mayor o igual que' },
];

export const LEFT_RIGHT_MIDDLE_OPTIONS = [
	'Ninguno',
	'Izquierda',
	'Derecha',
	'Centro',
	'Izquierda y derecha',
	'Izquierda y centro',
	'Derecha y centro',
	'Izquierda, derecha y centro',
];

export const BANKS = [
	'N/A',
	'BBVA',
	'SANTANDER',
	'BANORTE',
	'BANREGIO',
	'AFIRME',
	'INBURSA',
	'BANAMEX',
	'HSBC',
	'SCOTIABANK',
	'BANBAJÍO',
	'BANCO BASE',
	'BANXICO',
	'MONEX',
	'BANK OF AMERICA',
	'VARIOS',
	'OTRO',
];

export const CREDIT_OPTIONS = ['Sí', 'No', '90 días'];

export const APPOINTMENTS_NAMES = {
	toComplete: 'Pendientes',
	inProgress: 'En progreso',
	completed: 'Completados',
	cancelled: 'Cancelados',
	postponed: 'Postergados',
	totalEvents: 'Total citas',
	fullToComplete: 'Faltantes',
	dayRate: 'Avance del día',
};

export const MONTHS = [
	{ name: 'Enero', number: 1 },
	{ name: 'Febrero', number: 2 },
	{ name: 'Marzo', number: 3 },
	{ name: 'Abril', number: 4 },
	{ name: 'Mayo', number: 5 },
	{ name: 'Junio', number: 6 },
	{ name: 'Julio', number: 7 },
	{ name: 'Agosto', number: 8 },
	{ name: 'Septiembre', number: 9 },
	{ name: 'Octubre', number: 10 },
	{ name: 'Noviembre', number: 11 },
	{ name: 'Diciembre', number: 12 },
];

// Years (since the project started to the current year)
export const YEARS = ['2022', '2023', '2024'];

// Contact numbers when completing a process in a bias
export const DEFAULT_CONTACTS_PROCESS = [
	{ phone: '522226754831', name: 'Ing. Fernando López Ramírez' }, // Master
	{ phone: '522223107947', name: 'Leticia Martinez Espinobarros' }, // Mesa de control
	{ phone: '522211742308', name: 'Lic. Eduardo Sánchez' }, // Admin
	{ phone: '522222936073', name: 'Lic. Ricardo Sánchez' }, // Admin
	{ phone: '522225505238', name: 'Lic. Paulina Sánchez' }, // Admin
	{ phone: '522222938488', name: 'Lic. Ángel Serna' }, // Admin
	{ phone: '522227363704', name: 'Lic. Rocío Limón' }, // Gerencia de eficiencia
];

// Calendar areas priority
export const AREAS_PRIORITY = [
	{
		name: 'Almacén y Requerimientos',
		priority: 1,
		showing: true,
	},
	{
		name: 'Avíos y Comercios',
		priority: 2,
		showing: true,
	},
	{
		name: 'Patronaje',
		priority: 3,
		showing: true,
	},
	{
		name: 'Tela',
		priority: 4,
		showing: true,
	},
	{
		name: 'Corte',
		priority: 5,
		showing: true,
	},
	{
		name: 'Bordado',
		priority: 6,
		showing: true,
	},
	{
		name: 'Estampado',
		priority: 7,
		showing: true,
	},
	{
		name: 'Maquila Interna',
		priority: 8,
		showing: true,
	},
	{
		name: 'Maquila Externa',
		priority: 9,
		showing: true,
	},
	{
		name: 'Recepción',
		priority: 10,
		showing: true,
	},
	{
		name: 'Acabado',
		priority: 11,
		showing: true,
	},
	{
		name: 'Empaque, Embarque y Envío',
		priority: 12,
		showing: true,
	},
];

export const MATERIAL_COLORS = [
	// Primary Colors
	'#2196F3', // Blue
	'#F44336', // Red
	'#4CAF50', // Green
	'#FFEB3B', // Yellow
	'#FF9800', // Orange
	'#3F51B5', // Indigo
	'#03A9F4', // Light Blue
	'#00BCD4', // Cyan
	'#009688', // Teal
	'#8BC34A', // Light Green
	'#673AB7', // Deep Purple
	'#CDDC39', // Lime
	'#9C27B0', // Purple
	'#FFC107', // Amber
	'#E91E63', // Pink
	'#FF5722', // Deep Orange

	// Accent Colors
	'#607D8B', // Blue Grey
	'#795548', // Brown
	'#9E9E9E', // Grey
	'#607D8B', // Blue Grey
	'#795548', // Brown
	'#9E9E9E', // Grey
	// Add more accent colors as needed
];

export const AREA_COLORS = [
	{ area: 'Almacén y Requerimientos', color: '#1a237e' }, // Navy Blue
	{ area: 'Avíos y Comercios', color: '#2e7d32' }, // Forest Green
	{ area: 'Patronaje', color: '#ec407a' }, // Pink
	{ area: 'Tela', color: '#2e7d32' }, // Forest Green
	{ area: 'Corte', color: '#43a047' }, // Green
	{ area: 'Bordado', color: '#26c6da' }, // Turquoise Blue
	{ area: 'Estampado', color: '#ab47bc' }, // Light Purple
	{ area: 'Maquila Interna', color: '#bdbdbd' }, // Gray
	{ area: 'Maquila Externa', color: '#ff8f00' }, // Orange
	{ area: 'Recepción', color: '#2e86de' }, // Blue light
	{ area: 'Acabado', color: '#ad1457' }, // Wine
	{ area: 'Empaque, Embarque y Envío', color: '#ad1457' }, // Wine
];

export const EVENT_FIELDS_EN_ES_OBJ = {
	name: 'Título',
	address: 'Dirección',
	coordinates: 'Coordenadas',
	user: 'Usuario',
	created_at: 'Creado',
	user_id: 'ID Usuario',
	user_name: 'Nombre Usuario',
	displayName: 'Nombre Usuario',
	visit_time: 'Tiempo de visita',
	user_email: 'Email Usuario',
	datetime: 'Fecha y hora',
	first_check: 'Llegada',
	second_check: 'Salida',
	place_name: 'Lugar',
	first_check_time: 'Hora de llegada',
	second_check_time: 'Hora de salida',
	has_been_postpone: 'Se pospuso',
	justification_postpone: 'Justificación de postergación',
	cancelled: 'Fue cancelado',
	cancelled_time: 'Hora de cancelación',
	justification_cancel: 'Justificación de cancelación',
	user_ref: 'Referencia de usuario',
	rate: 'Puntuación',
	no_sales_reason: 'Razón de NO venta',
	visit_reason: 'Razón de visita',
	client_sector: 'Sector del cliente',
	client_level: 'Nivel de cliente',
	client_type: 'Tipo de cliente',
	extra_notes: 'Notas extras',
	car: 'Auto',
	division: 'División',
	rate_reason: 'Razón de puntuación',
	no_sale_subreason: 'Subrazón de NO venta',
	visit_subreason: 'Subrazón de visita',
	deleted: 'Eliminado',
};

export const reasonMapping = [
    { value: 'PRI', label: 'PRECIO' },
    { value: 'TDE', label: 'TIEMPO DE ENTREGA' },
    { value: 'CAL', label: 'CALIDAD' },
    { value: 'SER', label: 'SERVICIO' },
    { value: 'NPR', label: 'NO. PRENDAS' },
    { value: 'CCP', label: 'CUENTA CON PROVEEDOR' },
    { value: 'OTR', label: 'OTROS' },
];

export const referenceMapping = [
    { value: 'COT', label: 'CONTACTO' },
    { value: 'PRP', label: 'PROSPECTO' },
    { value: 'LEA', label: 'LEAL' },
    { value: 'CLI', label: 'CLIENTE' },
];

export const trafficLightMapping = [
    { value: 'GRN', label: 'Verde' },
    { value: 'YLW', label: 'Amarillo' },
    { value: 'RED', label: 'Rojo' },
    { value: 'NUL', label: '---' },
];

// Traffic light color
export const typeColor = {
    GRN: 'Verde',
    YLW: 'Amarillo',
    RED: 'Rojo',
};

// Styes for prospecting analysis table
export const columnStyles = {
    accion: { header: '#E0E0E0', color: '#424242' },
    contacto: { header: '#FFCDD2', color: '#B71C1C' },
    fecha1: { header: '#FFCDD2', color: '#B71C1C' },
    cita: { header: '#FFE0B2', color: '#E65100' },
    fecha2: { header: '#FFE0B2', color: '#E65100' },
    lead: { header: '#FFF9C4', color: '#F9A825' },
    fecha3: { header: '#FFF9C4', color: '#F9A825' },
    cotizacion: { header: '#BBDEFB', color: '#1E88E5' },
    fecha4: { header: '#BBDEFB', color: '#1E88E5' },
    cierre: { header: '#C8E6C9', color: '#2E7D32' },
    fecha5: { header: '#C8E6C9', color: '#2E7D32' },
};

// Action type mapping
export const typeAction = {
    LLA: 'LLAMADA',
    CRR: 'CORREO',
    CIT: 'CITA',
    CHA: 'CHAT',
    VID: 'VIDEO',
    ENC: 'EN CAMPO',
};

// Column titles for the prospecting analysis table
export const columnTitles = {
    accion: 'Acción',
    contacto: 'Contacto',
    fecha1: 'Fecha',
    cita: 'Cita',
    fecha2: 'Fecha',
    lead: 'Lead',
    fecha3: 'Fecha',
    cotizacion: 'Cotización',
    fecha4: 'Fecha',
    cierre: 'Cierre',
    fecha5: 'Fecha',
};